import Axios from 'axios';

const axiosBaseURL = Axios.create({
    baseURL:'https://clubinweb.in/'
});

export default axiosBaseURL